import divider from './divider.js'
export default { divider }
